//
// Swiper.jsをIONIC/Angularで利用する場合の説明が本家サイトにないので
// ネットを漁っていたら、いい方法を思いついて作っていた人がいたので
// それをそのままコピーしてきている。
//

import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  standalone: false,
  selector: '[appSwiper]'
})
export class SwiperDirective implements AfterViewInit {
  @Input() config?: SwiperOptions;

  constructor(private el: ElementRef<SwiperContainer>) { }

  ngAfterViewInit(): void {
    if(this.config && this.el.nativeElement) {
      Object.assign(this.el.nativeElement, this.config);
      this.el.nativeElement.initialize();
    } else {
      console.log( "SwiperDirective: config or element is not set" );
    }
  }
}
